var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsCalendarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 4h2c1.657 0 3 1.209 3 2.7v12.6c0 1.491-1.343 2.7-3 2.7H5c-1.657 0-3-1.209-3-2.7V6.7C2 5.209 3.343 4 5 4h2V3a1 1 0 012 0v1h6V3a1 1 0 012 0v1zM5 10a1 1 0 000 2h14a1 1 0 000-2H5z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTcgNGgyYzEuNjU3IDAgMyAxLjIwOSAzIDIuN3YxMi42YzAgMS40OTEtMS4zNDMgMi43LTMgMi43SDVjLTEuNjU3IDAtMy0xLjIwOS0zLTIuN1Y2LjdDMiA1LjIwOSAzLjM0MyA0IDUgNGgyVjNjMC0uNTUyLjQ0OC0xIDEtMXMxIC40NDggMSAxdjFoNlYzYzAtLjU1Mi40NDgtMSAxLTFzMSAuNDQ4IDEgMXYxek01IDEwYy0uNTUyIDAtMSAuNDQ4LTEgMXMuNDQ4IDEgMSAxaDE0Yy41NTIgMCAxLS40NDggMS0xcy0uNDQ4LTEtMS0xSDV6Ii8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconsCalendarFilled as ReactComponent };